import React from 'react';
import { Modal, Button } from 'react-bootstrap';

type Props = { show: boolean; onStay: () => void; onLeave: () => void };

export const UnsavedConfirm: React.FC<Props> = ({ show, onStay, onLeave }) => (
  <Modal show={show} onHide={onStay} centered>
    <Modal.Header closeButton><Modal.Title>Unsaved changes</Modal.Title></Modal.Header>
    <Modal.Body>
      <p className="mb-0">Unsaved changes will be lost.</p>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="light" onClick={onStay}>Stay</Button>
      <Button variant="primary" onClick={onLeave}>Leave without saving</Button>
    </Modal.Footer>
  </Modal>
);
